export const companyStats = {
    employees: 9,
    averageAge: 37,
    certificationRate: 80,
    projectsCompleted: 120,
    foundedYear: 2018,
};
export const staffInterviews = [
    {
        id: '1',
        name: '佐藤 健太',
        position: '電気工事士',
        image: '/images/recruit/member1.webp',
        comment: '若いスタッフが多く、新しいアイデアを積極的に取り入れる社風が魅力。資格取得のサポートも手厚く、技術を磨きながらキャリアアップできる環境です。',
    },
    {
        id: '2',
        name: '鈴木 美香',
        position: '総務',
        image: '/images/recruit/member2.webp',
        comment: '家庭との両立がしやすい働き方が整っています。現場と事務をつなぐ役割としてやりがいを感じながら、会社の成長に貢献できることが嬉しいです。',
    },
];
export const dailySchedule = [
    { time: '8:00', activity: '始業' },
    { time: '10:00', activity: '休憩' },
    { time: '12:00', activity: '昼休憩' },
    { time: '13:00', activity: '午後の作業' },
    { time: '15:00', activity: '休憩' },
    { time: '17:00', activity: '作業終了' },
    { time: '18:00', activity: '退社' },
];
export const recruitmentInfo = {
    positions: [
        {
            title: '電気工事士',
            requirements: '電気工事士資格保有者優遇（未経験者も応募可）',
            description: '建物の電気設備工事・保守管理を担当していただきます。',
        },
        {
            title: '空調設備技術者',
            requirements: '空調・配管工事の経験者優遇（未経験者も応募可）',
            description: '空調設備の設置・メンテナンス作業を担当していただきます。',
        },
        {
            title: '配管工',
            requirements: '空調・配管工事の経験者優遇（未経験者も応募可）',
            description: '空調設備の設置・メンテナンス作業を担当していただきます。',
        },
        {
            title: '施工管理',
            requirements: '空調・配管工事の経験者優遇（未経験者も応募可）',
            description: '空調設備の設置・メンテナンス作業を担当していただきます。',
        },
        {
            title: '営業職',
            requirements: '要普通自動車免許、コミュニケーション能力重視',
            description: '得意先への提案営業、新規顧客開拓を担当していただきます。',
        },
    ],
    benefits: [
        '制服・安全靴支給',
        '消耗品手当支給',
        '退職金制度あり',
        '社会保険完備',
        '各種休暇制度充実',
        '資格取得費用は会社全額負担',
    ],
    workHours: '8:00〜17:00（実働7時間）',
    holidays: '週休二日、その他会社が定める休日、有給休暇、ライフサポート休暇',
    location: '岩手県盛岡市津志田南3-13-15',
};
